// Filters Script -- colleciton page
document.addEventListener("DOMContentLoaded", () => {
  const filtersContainer = document.getElementById("filters-container");
  const sectionsContainer = document.getElementById("sections-container");
  const powerFilterContainer = document.getElementById("power-filter-container");

  const filters = Array.from(filtersContainer.querySelectorAll(".filter-option"));
  const sectionFilters = Array.from(sectionsContainer.querySelectorAll(".filter-option"));
  const powerFilters = Array.from(powerFilterContainer.querySelectorAll(".filter-option"));

  const loadMoreBtn = document.getElementById("load-more-filters");
  const clearButton = document.getElementById("clear-filters");
  const form = document.getElementById("variant-filter-form");
  const filterCount = document.getElementById("filter-count");
  const products = document.querySelectorAll(".filters-grid");

  let filtersToShow = 5;
  let clickCount = 0;

  function updateFilterVisibility() {
    filters.forEach((filter, index) => {
      filter.style.display = index < filtersToShow ? "block" : "none";
    });

    loadMoreBtn.style.display =
      filtersToShow >= filters.length ? "none" : "inline-block";
  }

  loadMoreBtn.addEventListener("click", () => {
    clickCount++;
    filtersToShow = clickCount === 1 ? 20 : filters.length;
    updateFilterVisibility();
  });

  // Hide filters if not available
  function hideEmptyFilterGroups() {
  const filterGroups = [
    { container: filtersContainer, label: "Color" },
    { container: sectionsContainer, label: "Section" },
    { container: powerFilterContainer, label: "Power" },
  ];

  let hasAnyFilters = false;

  filterGroups.forEach(({ container, label }) => {
    const hasOptions = container.querySelectorAll(".filter-option").length > 0;
    container.style.display = hasOptions ? "block" : "none";
    if (hasOptions) hasAnyFilters = true;

    console.log(`Filter group "${label}" is ${hasOptions ? "visible" : "hidden"}`);
  });

  // Hide the clear filters button if no filters exist
  const clearButton = document.getElementById("clear-filters");
  if (clearButton) {
    clearButton.style.display = hasAnyFilters ? "inline-block" : "none";
  }

  // Set global flag for other scripts to use
  window.hasAnyFilters = hasAnyFilters;
}


  // Function to apply the filters -- logic 
  function applyFilters() {
    const colorCheckboxes = form.querySelectorAll('input[name="color"]');
    const sectionCheckboxes = form.querySelectorAll('input[name="section"]');
    const powerCheckboxes = form.querySelectorAll('input[name="power"]');

    const selectedColors = Array.from(colorCheckboxes)
      .filter((cb) => cb.checked)
      .map((cb) => cb.value.toLowerCase());
    const selectedSections = Array.from(sectionCheckboxes)
      .filter((cb) => cb.checked)
      .map((cb) => cb.value.toLowerCase());
    const selectedPowers = Array.from(powerCheckboxes)
      .filter((cb) => cb.checked)
      .map((cb) => cb.value.toLowerCase());

    let visibleCount = 0;
    let styleSheet = document.getElementById("dynamic-filter-style");

    const hasFilters =
      selectedColors.length > 0 ||
      selectedSections.length > 0 ||
      selectedPowers.length > 0;

    if (hasFilters && !styleSheet) {
      styleSheet = document.createElement("style");
      styleSheet.id = "dynamic-filter-style";
      document.head.appendChild(styleSheet);
      styleSheet.textContent = `
        .grid-uniform .large--one-quarter:nth-child(4n+1) {
          clear: none !important;
        }
      `;
    } else if (!hasFilters && styleSheet) {
      styleSheet.remove();
      styleSheet = null;
    } else if (hasFilters && styleSheet) {
      styleSheet.textContent = `
        .grid-uniform .large--one-quarter:nth-child(4n+1) {
          clear: none !important;
        }
      `;
    }

    products.forEach((product) => {
      const productTitle = product.dataset.title?.toLowerCase() || "";
      const productVariants =
        product.dataset.variants?.toLowerCase().split(",") || [];
      const productSections =
        product.dataset.sections?.toLowerCase().split(",") || [];
      const productPowers =
        product.dataset.power?.toLowerCase().split(",") || [];

      const colorMatch =
        selectedColors.length === 0 ||
        selectedColors.some(
          (color) =>
            productTitle.includes(color) || productVariants.includes(color)
        );

      const sectionMatch =
        selectedSections.length === 0 ||
        selectedSections.some((section) => productSections.includes(section));

      const powerMatch =
        selectedPowers.length === 0 ||
        selectedPowers.some((power) => productPowers.includes(power));

      if (colorMatch && sectionMatch && powerMatch) {
        product.classList.remove("hidden");
        visibleCount++;
      } else {
        product.classList.add("hidden");
      }
    });

    filterCount.textContent = `Showing ${visibleCount} product${
      visibleCount !== 1 ? "s" : ""
    }`;
  }

  [...filters, ...sectionFilters, ...powerFilters].forEach((filter) => {
    const checkbox = filter.querySelector(".filter-checkbox");
    checkbox.addEventListener("change", applyFilters);
  });

  clearButton.addEventListener("click", () => {
    [...filters, ...sectionFilters, ...powerFilters].forEach((filter) => {
      const checkbox = filter.querySelector(".filter-checkbox");
      checkbox.checked = false;
    });
    applyFilters();
  });

  updateFilterVisibility();
  hideEmptyFilterGroups();
  applyFilters();
});

// Hide the filters button + make the grid 100% width
document.addEventListener("DOMContentLoaded", function () {
  // Wait briefly to ensure the first script has set the flag
  requestAnimationFrame(() => {
    const toggleBtn = document.getElementById("hide-filters");
    const filters = document.querySelector(".custom-filters");
    const grid = document.querySelector(".custom-grid-collection");

    const isMobile = window.innerWidth <= 768; // Mobile breakpoint

    if (!window.hasAnyFilters) {
      // No filters available, hide toggle button and expand grid
      if (toggleBtn) toggleBtn.style.setProperty("display", "none", "important");
      if (filters) filters.style.setProperty("display", "none", "important");
      if (grid) grid.style.setProperty("max-width", "100%", "important");
      return;
    }

    if (isMobile) {
      // Force-hide filters on mobile by default
      if (filters) filters.style.setProperty("display", "none", "important");
      if (grid) grid.style.setProperty("max-width", "100%", "important");
      if (toggleBtn) {
        toggleBtn.innerHTML = toggleBtn.innerHTML.replace(
          "Hide filters",
          "Show filters"
        );
      }
    }

    // Toggle logic
    toggleBtn.addEventListener("click", function () {
      const isHidden = filters.style.display === "none" || 
                       filters.style.getPropertyValue("display") === "none";

      if (isHidden) {
        filters.style.setProperty("display", "", "important"); // Remove inline override
        grid.style.setProperty("max-width", "", "important");
        toggleBtn.innerHTML = toggleBtn.innerHTML.replace(
          "Show filters",
          "Hide filters"
        );
      } else {
        filters.style.setProperty("display", "none", "important");
        grid.style.setProperty("max-width", "100%", "important");
        toggleBtn.innerHTML = toggleBtn.innerHTML.replace(
          "Hide filters",
          "Show filters"
        );
      }
    });
  });
});

// Accordion toggle functionality
document.querySelectorAll(".accordion-toggle").forEach((toggleBtn) => {
  toggleBtn.addEventListener("click", () => {
    const content = toggleBtn.nextElementSibling;
    toggleBtn.classList.toggle("open");
    content.classList.toggle("open");
  });
});

// Mobile Drawer
